import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer-container">
        <div className="footer-content">
            <div>
                <p className='footer-text-email'>&copy; calidad@universidadeuropea.es</p>
            </div>
            <div>
                <p className='footer-text'><a href="mailto:calidad@universidadeuropea.es" className='resultado-text'>Resultados</a> Encuestas Satisfacción con el Profesorado</p>
            </div>
        </div>
    </footer>
  );
};

export default Footer;
